import { useRef } from "react"
import { t } from "@lingui/core/macro"
import { Trans } from "@lingui/react/macro"
import { useAppContext } from "../../../../hooks/appContext"
import { useCountdownTimer } from "../../../../hooks/useCountDownTimer"
import { Sizes, Weights } from "../../../../interfaces/sizing"
import Button from "../../atoms/Button"
import "./PrivateLowBalanceToast.scss"
import { Link } from "../../atoms/Link"
import { Typography } from "../../atoms/Typography"

export const PrivateLowBalanceToast = ({
    openPuchasePage,
    closeToast,
    timeLeftInSec,
}: {
    openPuchasePage: ({
        source,
        roomType,
        target,
    }: {
        source: string
        roomType: string
        target: HTMLElement
    }) => void
    closeToast?: () => void
    timeLeftInSec: number
}) => {
    const buttonRef = useRef(null)
    const userName = useAppContext()?.context?.logged_in_user?.username
    const isMobile = useAppContext()?.context?.is_mobile

    const { timeLeft } = useCountdownTimer({
        initialTime: timeLeftInSec,
    })

    return (
        <div className="PrivateLowBalanceToast">
            <div className="PrivateLowBalanceToast__info">
                <Typography
                    size={Sizes.xspx}
                    weight={Weights.bold}
                    className="PrivateLowBalanceToast__title"
                >
                    {t`Your tokens are running low`}
                </Typography>
                <Typography
                    size={Sizes.xspx}
                >{t`Show will end in ${timeLeft}`}</Typography>
            </div>
            <div className="PrivateLowBalanceToast__purchButtonWrapper">
                <Button
                    ref={buttonRef}
                    text={t`Add Tokens`}
                    className="PrivateLowBalanceToast__purchaseButton"
                    onClick={() => {
                        openPuchasePage({
                            source: "TokenSourceLowTokenBalanceNotifyPrivateShow",
                            roomType: "private",
                            target: buttonRef.current!,
                        })
                        if (closeToast) {
                            closeToast()
                        }
                    }}
                />
            </div>
            {!isMobile && (
                <Typography
                    size={Sizes.xspx}
                    className="PrivateLowBalanceToast__help"
                >
                    <Trans>
                        To activate auto refill, go to{" "}
                        <Link
                            href={`/p/${userName}/?tab=settings&from_autorefill_link=1`}
                            target="_blank"
                        >
                            settings
                        </Link>
                        .
                    </Trans>
                </Typography>
            )}
        </div>
    )
}
